// QUOTE-EDIT — pure mapping from a saved quote (a GET /api/sales/quotes row) to the Sale form's state, so
// the Edit-quote / Convert drawer is the SAME create form, prefilled. No arithmetic: quantities and prices come back
// from the API as exact entry-unit text (qty_entry / price_entry).
export function quoteLineToFormLine(l) {
  const alloc = !!(l.storage_id && l.band_id);   // non-bird Direct line: storage + target (allocation) band
  return {
    item_id: l.item_id, qty: l.qty_entry ?? String(l.qty ?? ''), price: l.price_entry ?? String(l.price ?? ''),
    discount_pct: l.discount_pct != null ? String(l.discount_pct) : '',
    price_touched: true, price_source: null,   // the quoted price is the agreed price: never auto-replaced
    entry_unit: l.entry_unit || 'base', storage_id: l.storage_id || '',
    band_id: alloc ? '' : (l.band_id || ''), alloc_band_id: alloc ? l.band_id : '',
    revenue_attribution: l.revenue_attribution || '', revenue_account_override: l.revenue_account_override_id || '',
  };
}

// Convert (Quote unticked): the order is dated `orderDate` (today by default) and the quote's target date is
// kept only while it is still on/after the order date — a stale target is dropped (blank + highlighted)
// rather than carried into an order that would be born late.
export const convertEta = (eta, orderDate, convert) => (!eta || (convert && eta < orderDate) ? '' : eta);

export function quoteFormState(q, convert = false, today = '') {
  const lines = [...(q.lines || [])]
    .sort((a, b) => String(a.line_id || '').localeCompare(String(b.line_id || '')))
    .map(quoteLineToFormLine);
  return {
    form: { date: convert ? today : q.date, partner_id: q.partner_id || '', status: q.payment_method || 'Cash',
            account_to_id: q.account_to_id || '', notes: q.notes || '' },
    lines,
    expDate: convertEta(q.expected_delivery_date, convert ? today : q.date, convert),
    payDays: q.payment_method === 'Credit' && q.payment_days != null ? String(q.payment_days) : '',
  };
}
